import { render, staticRenderFns } from "./OpenOrderScreen.vue?vue&type=template&id=6834cbd3&scoped=true"
import script from "./OpenOrderScreen.vue?vue&type=script&lang=js"
export * from "./OpenOrderScreen.vue?vue&type=script&lang=js"
import style0 from "./OpenOrderScreen.vue?vue&type=style&index=0&id=6834cbd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6834cbd3",
  null
  
)

export default component.exports